import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Select from 'react-select';

const CboCurso = ({ selectedValue, onChange, disabled, grupo, empresa, seccion }) => {

  const [cursos, setCursos] = useState([])

  ///const location = useLocation();    



  useEffect(() => {


    // var { unaSeccion } = location.state || {};
    console.log('Sección de cursos:', seccion);


    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();

    consulta.grupo = grupo;
    consulta.empresa = empresa;
    consulta.seccion = seccion;

    if (seccion) {
      jsons3 = JSON.stringify(consulta);


      var options3 = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'

        },
        mode: 'cors',
        credential: 'include',
        body: jsons3,

      };

      url3 = `${process.env.REACT_APP_API_URL}/cur/allcursos`;



      fetch(url3, options3)
        .then(response => response.json())
        .then(data => {

          json3 = data;
          console.log("Cursos:", json3.data);
          setCursos(json3.data);

          if (json3.data.length > 0) {
            var primerId;
            if (selectedValue) {
              primerId = selectedValue;
            }
            else {
              primerId = json3.data[0].Cur_IdCur;
            }

            const eventoSimulado = {
              target: {
                value: primerId
              }
            };
            onChange(eventoSimulado);
          }



        })
    }

  }, [seccion]);



  const opcionesCursos = [
    { value: 0, label: 'todos los cursos' },

    ...cursos.map((unolista) => ({
      value: unolista.Cur_IdCur,
      label: unolista.Cur_Nombre
    }))
  ];

  const cursoSeleccionado =
    opcionesCursos.find(op => op.value === selectedValue);


  return (
    /*
        <div className={"col-lg-offset-0 col-lg-2 col-xs-12 col-sm-4"}>
          <div className="form-group">
            <label className="l" htmlFor="exampleInputEmail1">Curso</label>

            <select className={`form-control form-select mb-3  `} value={selectedValue} onChange={onChange} disabled={disabled}  >
              <option key={'0_opt'} value={0}  >{"todos los cursos"}</option>
              {cursos.map((unolista, index) => (
                <option key={index + '_opt'} value={unolista.Cur_IdCur}  >{unolista.Cur_Nombre}</option>
    
    
              )
              )
              }
    
            </select>
          </div>
        </div> */


    <div className={"col-lg-offset-0 col-lg-2 col-xs-12 col-sm-4"}>
      <div className="form-group">

        <label className="l">
          Curso
        </label>

        <Select
          classNamePrefix="miSelect"
          isSearchable={false}
          options={opcionesCursos}
          value={cursoSeleccionado}
          onChange={(opcion) =>
            onChange({
              target: {
                value: opcion.value || 0
              }
            })
          }
          isDisabled={disabled}
        />

      </div>
    </div>

  );
};

export default CboCurso;